import { useTheme } from '@mui/material';

import endToEndOwnershipIcon from '../../../public/svg/icons/zkdWhyRF/endToEndOwnership.svg';
import engineeringFirstApproachIcon from '../../../public/svg/icons/zkdWhyRF/engineeringFirstApproach.svg';
import protocolAgnosticIcon from '../../../public/svg/icons/zkdWhyRF/protocolAgnostic.svg';
import weActuallyShipCodeIcon from '../../../public/svg/icons/zkdWhyRF/weActuallyShipCode.svg';

export const WhyRFData = () => {
  const theme = useTheme();
  return [
    {
      name: 'we_actually_ship_code',
      icon: weActuallyShipCodeIcon,
      title: 'We Actually Ship Code',
      boxShadow: theme.mixins.orangeGradientTransparent?.boxShadow || '',
      duration: 4,
      floatingY: 7.4,
      description:
        "While others are publishing research papers, we're delivering production systems. Our team has a track record of taking ZK projects from concept to mainnet launch.",
    },
    {
      name: 'engineering_first_approach',
      icon: engineeringFirstApproachIcon,
      title: 'Engineering-First Approach',
      boxShadow: theme.mixins.redGradientTransparent?.boxShadow || '',
      duration: 5,
      floatingY: 3,
      description:
        "We're builders who focus on solving technical challenges. Expect clear communication, realistic timelines, and solutions that work in production environments.",
    },
    {
      name: 'protocol_agnostic',
      icon: protocolAgnosticIcon,
      title: 'Protocol Agnostic',
      boxShadow: theme.mixins.magentaGradientTransparent?.boxShadow || '',
      duration: 2,
      floatingY: 4.5,
      description: 'We work with the best tools for your specific use case:',
      list: [
        {
          title: 'Ethereum & Layer 2s',
          description: 'zkSync, Polygon zkEVM, StarkNet',
        },
        {
          title: 'ZK Libraries',
          description: 'Circom, SnarkJS, arkworks, Halo2',
        },
        {
          title: 'Languages',
          description: 'Rust, Solidity, JavaScript/TypeScript',
        },
        {
          title: 'Frameworks',
          description: 'Whatever gets the job done efficiently',
        },
      ],
    },
    {
      name: 'end_to_end_ownership',
      icon: endToEndOwnershipIcon,
      title: 'End-to-End Ownership',
      boxShadow: theme.mixins.blueGradientTransparent?.boxShadow || '',
      duration: 3,
      floatingY: 4.5,
      description:
        "From initial architecture to post-launch support, we stick around. No 'build and disappear' approach.",
    },
  ];
};
